// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nz0z","label":"styles_label__262uQ"};